import { AmplifyRecord } from '@akin-home/amplify';
import { filterHasValue } from '@akin-home/arrays';
import { z } from 'zod';

export const SystemPropertyModel = AmplifyRecord.extend({
  name: z.string(),
  label: z.string(),
  description: z.string().nullish(),
  value: z.string().nullish(),
  public: z.boolean().nullish(),
  read_groups: z
    .array(z.string().nullable())
    .transform(filterHasValue)
    .nullish(),
});

export type SystemPropertyModel = z.infer<typeof SystemPropertyModel>;
